<template>
<div>
  <div class="float-start">
    <select v-model="selectedRowPerPage" @change="changeRowPerPage">
      <option v-for="(i,idx) in rowPerPageArr" :key="idx" :value="i">{{i}}</option>
    </select>
  </div>
  <div class="float-end">
    <nav aria-label="...">
      <ul class="pagination pagination-sm">

        <li class="page-item">
          <button class="page-link" @click="clickFirst">First</button>
        </li>

        <li class="page-item" :class="pagingParam.currentPage <= 1 ?'disabled':''">
          <span v-if="pagingParam.currentPage <= 1" class="page-link"><i class="bi bi-chevron-left small"></i></span>
          <button v-else class="page-link" @click="clickPrev"><i class="bi bi-chevron-left small"></i></button>
        </li>

        <li v-for="(i,idx) in pagingParam.totalPage" v-show="showOrHideItem(i)" :key="idx" class="page-item" :class="pagingParam.currentPage==i?'active':''">
          <button class="page-link" @click="clickPage(i)">{{i}}</button>
        </li>

        <li class="page-item" :class="pagingParam.currentPage >= pagingParam.totalPage ?'disabled':''">
          <span v-if="pagingParam.currentPage >= pagingParam.totalPage" class="page-link"><i class="bi bi-chevron-right small"></i></span>
          <button v-else class="page-link" @click="clickNext"><i class="bi bi-chevron-right small"></i></button>
        </li>

        <li class="page-item">
          <button class="page-link" @click="clickLast">Last</button>
        </li>

      </ul>
    </nav>
  </div>
  <div class="float-end text-secondary small" style="padding:5px;">
    {{pagingParam.startRow}} to {{pagingParam.endRow}} of {{pagingParam.totalRow}}
  </div>
</div>
</template>

<script>

export default {
  name: 'Pagination',
  props: {
    pagingParam: Object
  },
  data() {
    return {
      rowPerPageArr: [10, 50, 100, 200],
      selectedRowPerPage: 0,
      paramObj: {}
    }
  },
  mounted() {
    console.log(this.pagingParam.rowPerPage);
    this.selectedRowPerPage = this.pagingParam.rowPerPage;
  },
  methods: {
    getParamObj() {
      return { ...this.pagingParam };
    },
    updateParams(obj) {
      this.$emit('updatePaging', obj)
    },
    clickPrev() {
      if (this.pagingParam.currentPage > 1) {
        let obj = this.getParamObj();
        obj.currentPage = this.pagingParam.currentPage - 1;
        this.updateParams(obj);
      }
    },
    clickNext() {
      if (this.pagingParam.currentPage < this.pagingParam.totalPage) {
        let obj = this.getParamObj();
        obj.currentPage = this.pagingParam.currentPage + 1;
        this.updateParams(obj);
      }
    },
    clickPage(i) {
      if (this.pagingParam.currentPage != i) {
        let obj = this.getParamObj();
        obj.currentPage = i;
        this.updateParams(obj);
      }
    },
    clickFirst() {
      if (this.pagingParam.currentPage != 1) {
        let obj = this.getParamObj();
        obj.currentPage = 1;
        this.updateParams(obj);
      }
    },
    clickLast() {
      if (this.pagingParam.currentPage != this.pagingParam.totalPage) {
        let obj = this.getParamObj();
        obj.currentPage = this.pagingParam.totalPage;
        this.updateParams(obj);
      }
    },
    changeRowPerPage() {
      let obj = this.getParamObj();
      obj.rowPerPage = this.selectedRowPerPage;
      this.updateParams(obj);
    },
    showOrHideItem(i) {
      let from = this.pagingParam.currentPage - 3;
      let to = this.pagingParam.currentPage + 3;

      if (from < 1)
        to += 1 - from;
      if (to > this.pagingParam.totalPage)
        from += this.pagingParam.totalPage - to;

      if (i >= from && i <= to)
        return true;
      else
        return false;
    }
  }
}
</script>
